import React, { useImperativeHandle, useState } from 'react';
import Alert from '@app/model/alert/Alert';
import Drawer from '@app/component/overlays/drawer/Drawer';
import useDrawer from '@app/component/overlays/drawer/DrawerRef';
import AlertExecution from '@app/model/alert/AlertExecution';
import _isEmpty from 'lodash/isEmpty';
import Message from '@app/component/message/Message';
import Utilities from '@util/Utilities';
import AlertService from '@app/model/alert/service/AlertService';
import AlertExecutionState from '@app/model/alert/AlertExecutionState';
import { useSelectedCompanyHotel } from '@app/site/secured/rateshopper/rates/provider/useSelectedCompanyHotel';


const AlertLogDrawer: React.FunctionComponent<{ ref: any }> = React.forwardRef(({}, ref: React.Ref<any>) => {

    const drawer = useDrawer();
    const [executions, setExecutions] = useState<AlertExecution[]>()
    const [isLoading, setIsLoading] = useState<boolean>(true);
		const {companyHotel} = useSelectedCompanyHotel();


    useImperativeHandle(ref, () => {
        return {
            open: (alert: Alert) => {
                AlertService.findAlertExecutions(companyHotel.id, alert.id).then(setExecutions).finally(() => setIsLoading(false));
                drawer.open()
            }
        }
    });

    return <Drawer title="Alert Log" ref={drawer.ref}>
        <div className="mt-6">
            <div className="px-4 sm:px-6 mt-5">
                {isLoading && <ul role="list" className="space-y-6">
                    {[...Array(5)].map((x, i) => <div key={i} className="w-full animate-pulse">
                        <div className="h-4 bg-gray-200 rounded-full w-12 mb-4"></div>
                        <div className="h-2.5 bg-gray-200 rounded-full mb-2"></div>
                        <div className="h-2.5 bg-gray-200 rounded-full mb-2"></div>
                    </div>)}
                </ul>}
                {!isLoading && _isEmpty(executions) && <Message state="info">There is no log currently!</Message>}
                {!isLoading && !_isEmpty(executions) && <ul role="list" className="space-y-6">
                    {executions!.map(execution => <li key={execution.id} className="relative flex gap-x-4">
                        <div className="absolute left-0 top-0 flex w-6 justify-center -bottom-6">
                            <div className="w-px bg-gray-200"></div>
                        </div>
                        <div className="relative flex h-6 w-6 flex-none items-center justify-center bg-white">
                            <div
                                className={Utilities.classNames("h-2 w-2 rounded-full", execution.state === AlertExecutionState.EMPTY ? "bg-blue-200 ring-1 ring-blue-400" : "bg-gray-100 ring-1 ring-gray-300")}></div>
                        </div>
                        <ul className="flex-auto py-0.5 text-xs leading-5 text-gray-500">
                            <li><span
                                className="font-medium text-gray-900">{Utilities.formatDateString(execution.executionDate, 'DD/MM/YYYY')}</span><span
                                className="ml-2 text-gray-500">{Utilities.formatDateString(execution.executionDate, 'HH:mm')}</span>
                            </li>
                            <li>{execution.numberOfNotifications || 0} alerts</li>
                        </ul>
                        {(execution.state === AlertExecutionState.SUCCEEDED || execution.state === AlertExecutionState.SUCCEEDED_NO_UPDATES && execution.numberOfNotifications > 0) &&
                            <div className="flex-none py-0.5 text-xs leading-5 text-gray-500"><a
                                className="text-blue-600 font-semibold hover:text-blue-900" title="See details"
                                href={`/secured/rateshopper/rates/alert/execution/${execution.id}`}>Open</a></div>}
                        {execution.state === AlertExecutionState.FAILED &&
                          <div className="flex-none py-0.5 text-xs leading-5 text-gray-500">
                              Failed
                          </div>}
                    </li>)}
                </ul>}
            </div>
        </div>
    </Drawer>
})
export default AlertLogDrawer;